import React from 'react';
import { Link } from 'react-router-dom';
import classes from './NotFound.module.css';
import Seo from './components/Seo';
import Header from './components/Header';
import Footer from './components/Footer';
import { useI18n } from './i18n/LanguageContext';

function NotFound() {
  const { t, path } = useI18n();

  return (
    <div className={classes.page}>
      <Seo
        title={t('meta.notFound.title')}
        description={t('meta.notFound.description')}
        routePath="/404"
        noindex
      />
      <Header />
      <main className={classes.main}>
        <h1 className={classes.code}>404</h1>
        <p className={classes.text}>{t('notFound.text')}</p>
        <div className={classes.links}>
          <Link to={path('/')} className={classes.homeLink}>
            {t('notFound.backHome')}
          </Link>
          <Link to={path('/blog')} className={classes.blogLink}>
            {t('notFound.readBlog')}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default NotFound;
